<template>
  <b-card no-body class="mt-6">
    <ActionViewpopup
      :isActiveView="openAddBannerSidebar"
      :ViewApplicationreq="viewObj"
      @close="toggleAddBannerSidebar"
    />

    <div class="flex mt-8 mb-2">
      <div class="w-full mr-4">
        <b-input-group class="">
          <b-form-input
            class="border-none shadow-lg ml-4"
            type="text"
            min="0.00"
            v-model="search"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="allWithdrawalRequest.result"
      border
    >
      <el-table-column
        label="Sr. No"
        type="index"
        :index="indexMethod"
        width="60px"
      ></el-table-column>
      <el-table-column
        label="Withdrawal ID"
        min-width="150px"
        prop="srno"
        v-slot="{ row }"
        >{{ row._id }}</el-table-column
      >
      <el-table-column
        label="Volunteer Name"
        min-width="150px"
        prop="name"
        v-slot="{ row }"
        >{{ row.userId.firstname + " " + row.userId.lastname }}
      </el-table-column>
      <el-table-column
        label="Mobile Number"
        prop="mobile"
        min-width="150px"
        v-slot="{ row }"
        >{{ row.userId.mobile }}
      </el-table-column>

      <el-table-column
        label="Withdraw Amount"
        prop="email"
        min-width="150px"
        v-slot="{ row }"
        >{{ row.withdrawAmt }}
      </el-table-column>

      <el-table-column label="Bank Info" min-width="150px" prop="bankinfo">
        <template v-slot="{ row }">
          <span @click="handleView(true, row)">View</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Withdrawal Status"
        min-width="150px"
        prop="bankinfo"
      >
        <template v-slot="{ row }">
          <div
            class="gap-2 flex justify-center"
            v-if="
              row.withdrawStatus === null ||
              row.withdrawStatus === 'Pending' ||
              row.withdrawStatus === undefined
            "
          >
            <div>
              <feather-icon
                icon="CheckIcon"
                class="border-none rounded-sm text-success cursor-pointer"
                @click="handleStatus('Completed', row)"
              />
            </div>
            <div>
              <feather-icon
                icon="XIcon"
                class="border-none rounded-sm text-danger cursor-pointer"
                @click="handleStatus('Cancelled', row)"
              />
            </div>
          </div>
          <div class="gap-2 flex justify-center" v-else>
            <div
              :class="
                row.withdrawStatus === 'Approved'
                  ? 'text-success'
                  : 'text-danger'
              "
            >
              {{ row.withdrawStatus }}
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="total_row"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import ActionViewpopup from "./ActionViewpopup.vue";
import { mapState } from "vuex";
export default {
  components: {},
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    ActionViewpopup,
  },
  computed: {
    toggled() {
      return this.userToggle;
    },
  },
  data() {
    return {
      userToggle: false,
      viewObj: {},
      currentPage: 1,
      openAddBannerSidebar: false,
      // user: [
      //   {
      //     srno: 1234556,
      //     name: "manisha sharma",
      //     mobile: 9865321478,
      //     email: "megha.bhagirath@aiab.in",
      //     bankinfo: "",
      //   },
      // ],
      search: "",
      total_row: 1,
      perPage: 10,
    };
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.getAllRequest();
      }, 500),
    },
  },
  methods: {
    async handleView(val = false, data = null, amt) {
      if (val) await this.ViewApplicationsDetails(data, amt);
      // this.viewObj = item;
      this.openAddBannerSidebar = val;
    },
    async ViewApplicationsDetails(val) {
      let payload = {
        volunteerId: val.volunteerId._id,
        noAdminRequired: true,
      };
      const { data } = await this.$store.dispatch(
        "respitecare/get_volunteerbyid",
        payload
      );
      Object.assign(data, {
        withdrawAmt: val.withdrawAmt,
      });
      this.viewObj = data;
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    async getAllRequest() {
      let payload = {
        search: this.search.trim(),
        limit: 10,
        offset: (this.currentPage - 1) * 10,
      };
      try {
        await this.$store.dispatch("respitecare/getAllWithdrawal", payload);
        this.total_row = this.allWithdrawalRequest.totalCount;
      } catch (error) {
        console.log(error);
      }
    },
    indexMethod(index) {
      return this.perPage * (this.currentPage - 1) + index + 1;
    },
    handlePageChange(value) {
      this.currentPage = value;
      try {
        this.getAllRequest();
      } catch (error) {}
    },
    async handleStatus(status, val) {
      let payload = {
        _id: val._id,
        withdrawStatus: status,
      };
      try {
        await this.$store.dispatch("respitecare/editWithdrawal", payload);
        this.getAllRequest();
        this.$swal.fire({
          title: "Status Updated",
          text: "Volunteer's withdrawal status updated successfully!",
          icon: "success",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState("auth", { user: "user" }),
    ...mapState("respitecare", ["allWithdrawalRequest"]),
  },
  async mounted() {
    await this.getAllRequest();
  },
};
</script>
